/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { PageMetadata } from './page-metadata';
import { PraticaEsercenteSummaryDTO } from './pratica-esercente-summary-dto';


export interface PagedModelPraticaEsercenteSummaryDTO { 
    content?: Array<PraticaEsercenteSummaryDTO>;
    page?: PageMetadata;
}

